import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n";

const formatDate = (iso, lang) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString(lang === "it" ? "it-IT" : "en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return iso;
  }
};

export const readingTime = (text = "") => Math.max(1, Math.round(text.split(/\s+/).length / 200));

export default function ArticleCard({ article, testid, showViews = false }) {
  const { lang, t } = useLanguage();
  const title = (lang === "en" && article.title_en) || article.title;
  const excerpt = (lang === "en" && article.excerpt_en) || article.excerpt;
  return (
    <Link
      to={`/articoli/${article.slug}`}
      data-testid={testid}
      className="group flex flex-col h-full border border-slate-200 bg-white hover:border-brand/50 transition-colors duration-300"
    >
      {article.cover_image && (
        <div className="overflow-hidden h-52">
          <img
            src={article.cover_image}
            alt={title}
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
          />
        </div>
      )}
      <div className="flex flex-col flex-1 p-6">
        <p className="eyebrow">{article.category}</p>
        <h3 className="mt-3 font-serif text-2xl leading-snug text-slate-900 group-hover:text-brand transition-colors duration-300">
          {title}
        </h3>
        <p className="mt-3 text-sm font-light leading-relaxed text-slate-600 line-clamp-3">{excerpt}</p>
        <div className="mt-auto pt-5 flex items-center justify-between text-[11px] uppercase tracking-[0.2em] text-slate-400">
          <span>{formatDate(article.published_at, lang)}</span>
          <span data-testid={showViews ? `${testid}-views` : undefined}>
            {showViews
              ? `${article.views ?? 0} ${t.treatments.reads}`
              : `${readingTime(article.content)} min`}
          </span>
        </div>
      </div>
    </Link>
  );
}
